module.exports = __webpack_public_path__ + "static/media/coins.04cb78de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins.svg
// module id = 1381
// module chunks = 0